<h2 mat-dialog-title>Crear árbol de pregunta</h2>
<form [formGroup]="associateQuestionForm" (ngSubmit)="createAssociateQuestions()">
    <mat-dialog-content class="mat-typography">
    <div class="associate-container">
        <div class="associate-section scroll">
            <div class="associate-create-section">
                <label for="">Pregunta padre</label>
                <textarea disabled="true" class="associate-text-area" id="" cols="10" rows="5"
                [value]="mainQuestionTitle"></textarea>
                <label for="">Opciones</label>
                <div class="associate-entry" *ngFor="let option of associateQuestionForm.controls.opciones?.value; let optioni = index;">
                    <div class="associate-entry-section">
                        <input type="text" name="descripcion" [value]="option.descripcion"
                        class="form-control form-control-sm form-margin" (change)="optionChange( $event, optioni )">
                    </div>
                    <div class="associate-entry-section">
                        <select class="form-control form-control-sm" id="activo" (change)="optionChange( $event, optioni )">
                            <option [value]="0" [selected]="option.preguntas_hijas.length === 0">
                                Ninguna pregunta
                            </option>
                            <option [value]="1" [selected]="option.preguntas_hijas.length > 0">
                                Siguiente pregunta
                            </option>
                        </select>
                    </div>
                </div>
                <button mat-button class="multiple-btn" type="button" (click)="newOptionInput()"><mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>Agregar opción de respuesta</button>
            </div>
            <div *ngFor="let question of associateQuestionForm.controls.opciones.value">
                <div class="associate-create-section"
                    *ngIf="(question.preguntas_hijas.length > 0)
                        ? (question.preguntas_hijas[0]?.titulo) ? question.preguntas_hijas[0]?.titulo : question.preguntas_hijas[0]?.descripcion
                        : false">
                    <label for="">{{ question.descripcion }}</label>
                    <textarea disabled="true" class="associate-text-area" id="" cols="10" rows="5"
                    [value]="(question.preguntas_hijas.length > 0)
                    ? (question.preguntas_hijas[0]?.titulo) ? question.preguntas_hijas[0]?.titulo : question.preguntas_hijas[0]?.descripcion
                    : false"></textarea>
                </div>
            </div>
        </div>
        <div class="associate-section">
            <mat-card class="associate-card">
                <label for="">{{ mainQuestionTitle }}</label>
                <div>
                    <mat-radio-group class="associate-view" [(ngModel)]="viewOptionSelected" [ngModelOptions]="{standalone: true}">
                            <mat-radio-button class="associate-view-option" *ngFor="let question of associateQuestionForm.controls.opciones.value"
                             [value]="question">
                                {{ question.descripcion }}
                            </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div>
                    <textarea disabled="true" class="associate-text-area" id="" cols="10" rows="5"
                    [value]="(viewOptionSelected?.preguntas_hijas[0]?.titulo)
                        ? viewOptionSelected?.preguntas_hijas[0]?.titulo
                        : viewOptionSelected?.preguntas_hijas[0]?.descripcion"></textarea>
                </div>
            </mat-card>
        </div>
    </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button mat-button color="primary" type="submit" [disabled]="validationFormOptions()" [mat-dialog-close]="true" cdkFocusInitial>Guardar y finalizar</button>
    </mat-dialog-actions>
</form>